import { render, staticRenderFns } from "./importDetailProduct.vue?vue&type=template&id=25f09faf&scoped=true&"
import script from "./importDetailProduct.vue?vue&type=script&lang=js&"
export * from "./importDetailProduct.vue?vue&type=script&lang=js&"
import style0 from "./importDetailProduct.vue?vue&type=style&index=0&id=25f09faf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f09faf",
  null
  
)

export default component.exports